<div class="agent-proxy-layout">
  <div class="loader-content" *ngIf="isLoading">
    <div class="spinner">
      <mat-spinner [diameter]="60"></mat-spinner>
    </div>
    <div class="loader-text">
      <div class="text-message">{{ loaderMessage }}</div>
    </div>
  </div>
  <div class="container" *ngIf="!isLoading">
    <div class="close-icon">
      <div class="main_title">
        <i class="icon mdi mdi-pencil"></i>
        <span
          ><b>{{ title }}</b></span
        >
        <a class="download-link" matTooltip="Download" [attr.href]="downloadProxyURLPath"
          ><i class="icon icon-color mdi mdi-download"></i>
          <span class="download-label">Download</span></a
        >
      </div>
      <i class="mdi mdi-close" (click)="close()"></i>
    </div>
    <div class="container-body">
      <div class="label">
        <span class="proxy-description"
          >An Agent Control Proxy can be deployed to allow agents that are not on the enterprise
          network (Off-Prem) communicate with the test server deployed in the enterprise network
          (On-Prem). Please check the Agent guide for details on using this feature.</span
        >
        <form name="proxyform" #proxyForm="ngForm" class="proxy-input">
          <div class="group proxy-url">
            <span class="sub-label"><b>Agent Control Proxy: </b> https://</span>
            <input
              autocomplete="off"
              class="input-data"
              type="text"
              [(ngModel)]="proxyURL"
              name="proxyURL"
              (ngModelChange)="proxyURLChange()"
              #proxyURLInput="ngModel"
              required
              maxlength="50"
            />
            <div
              class="error"
              *ngIf="proxyURLInput.invalid && (proxyURLInput.dirty || proxyURLInput.touched)"
            >
              <mat-error *ngIf="proxyURLInput.errors.maxlength">Proxy URL is too long.</mat-error>
              <mat-error *ngIf="proxyURLInput.errors.required">Proxy URL is required.</mat-error>
              <mat-error *ngIf="proxyURLInput.errors.regex && !proxyURLInput.errors.required">{{
                proxyURLValidationMsg
              }}</mat-error>
            </div>
          </div>
        </form>
        <div class="warning-message">
          <b>Warning: </b
          ><span class="notes"
            >This feature is still under construction. To use the Agent Control Proxy you must
            manually configure the agent to make use of it.</span
          >
        </div>
      </div>
    </div>
    <div class="btn-align">
      <button
        mat-flat-button
        (click)="saveProxy()"
        *ngIf="!isProxyRes"
        [disabled]="proxyURLInput.invalid"
      >
        Save
      </button>
      <button
        mat-flat-button
        (click)="updateProxy()"
        *ngIf="isProxyRes"
        [disabled]="proxyURLInput.invalid"
      >
        Update
      </button>
      <button
        mat-flat-button
        class="btn-remove"
        (click)="removeProxyConfirmation()"
        *ngIf="isProxyRes"
        [disabled]="proxyURLInput.invalid"
      >
        Delete
      </button>
      <button mat-button="" mat-dialog-close="" type="button" (click)="onCancel()">
        <span class="mat-button-wrapper"> Cancel </span>
        <span class="mat-button-focus-overlay"></span>
      </button>
    </div>
  </div>
</div>
